import React from 'react';
import Stores from './Stores';
import currentUserState from '@globalState/currentUserState';

export default () => {
  const currentUser = currentUserState.useValue();
  return <div>{currentUser?.isAdmin || currentUser?.isMaster ? <Stores /> : null}</div>;
};
